<template>
  <div class="Moblie-Details">
    <div class="Details-main">
      <div class="back">
        <img
          src="../../../../assets/image/Mobile/icon/MoblieBack.svg"
          @click="backbtn"
        />
        <div class="chainname2 load1" v-if="loadingpage"></div>
        <div class="chainname" v-else>
          <img :src="icon(title.NetWorkIcon)" />
          <div>{{ title.NetWork }}</div>
        </div>
      </div>
      <div class="title-list">
        <div class="icon2 load1" v-if="loadingpage"></div>
        <div class="icon" v-else>
          <img :src="icon(title.TokenIcon)" />
          <div class="token-name">
            <div class="n1">{{ title.TokenName }}</div>
            <div class="n2">{{ title.TokenName2 }}</div>
          </div>
        </div>
        <div class="d1">
          <div>Oracle Price</div>
          <div class="dd load1" v-if="loadingpage"></div>
          <div v-else>${{ toFixedNumber(title.OraclePrice, 2, true) }}</div>
        </div>
        <div class="d1">
          <div>Available Liquidity</div>
          <div class="dd load1" v-if="loadingpage"></div>
          <div v-else>
            ${{ toFixedNumber(title.AvailableLiquidity, 2, true) }}
          </div>
        </div>
        <div class="d1">
          <div>
            <span>LTV</span>
            <!--          <a-popover :title="false" placement="top">-->
            <!--            <template #content>-->
            <!--              <p style="font-weight: 400;font-size: 10px;color: #8F9092;font-family: 'GT America Trial Ext Rg';padding-top: 15px;width: 169px">The maximum percentage of the collateral value available to be borrowed.<br />-->
            <!--              </p>-->
            <!--            </template>-->
            <!--            <div @mouseenter="iconHighlight2=false" @mouseleave="iconHighlight2=true" v-if="themetype">-->
            <!--              <img src="../../../../assets/image/dark/question3.svg" style="cursor: pointer;width: 12px;height: 12px" v-if="iconHighlight2">-->
            <!--              <img src="../../../../assets/image/icon/question2.svg" style="cursor: pointer;width: 12px;height: 12px" v-else>-->
            <!--            </div>-->
            <!--            <div @mouseenter="iconHighlight3=false" @mouseleave="iconHighlight3=true" v-else>-->
            <!--              <img src="../../../../assets/image/icon/question.svg" style="cursor: pointer;width: 12px;height: 12px" v-if="iconHighlight3">-->
            <!--              <img src="../../../../assets/image/icon/question2.svg" style="cursor: pointer;width: 12px;height: 12px" v-else>-->
            <!--            </div>-->

            <!--          </a-popover>-->
          </div>
          <div class="dd load1" v-if="loadingpage"></div>
          <div v-else>{{ toFixedCutZero(title.LTV * 100, 2, false) }}%</div>
        </div>
        <div class="d1">
          <div>
            <span>Liquidation Threshold</span>
            <a-popover :title="false" placement="top">
              <template #content>
                <p
                  style="
                    font-weight: 400;
                    font-size: 10px;
                    color: #8f9092;
                    font-family: 'GT America Trial Ext Rg';
                    padding-top: 15px;
                    width: 169px;
                  "
                >
                  The maximum percentage of the collateral value beyond which a
                  borrow position is considered uncollateralized. The collateral
                  will then be available for liquidation.<br />
                </p>
              </template>
              <div
                @mouseenter="iconHighlight2 = false"
                @mouseleave="iconHighlight2 = true"
                v-if="themetype"
              >
                <img
                  src="../../../../assets/image/dark/question3.svg"
                  style="cursor: pointer; width: 12px; height: 12px"
                  v-if="iconHighlight2"
                />
                <img
                  src="../../../../assets/image/icon/question2.svg"
                  style="cursor: pointer; width: 12px; height: 12px"
                  v-else
                />
              </div>
              <div
                @mouseenter="iconHighlight1 = false"
                @mouseleave="iconHighlight1 = true"
                v-else
              >
                <img
                  src="../../../../assets/image/icon/question.svg"
                  style="cursor: pointer; width: 12px; height: 12px"
                  v-if="iconHighlight1"
                />
                <img
                  src="../../../../assets/image/icon/question2.svg"
                  style="cursor: pointer; width: 12px; height: 12px"
                  v-else
                />
              </div>
            </a-popover>
          </div>
          <div class="dd load1" v-if="loadingpage"></div>
          <div v-else>
            {{ toFixedCutZero(title.Threshold * 100, 2, false) }}%
          </div>
        </div>
        <div class="d2">
          <div>
            <span>Liquidation Bonus</span>
            <a-popover :title="false" placement="top">
              <template #content>
                <p
                  style="
                    font-weight: 400;
                    font-size: 10px;
                    color: #8f9092;
                    font-family: 'GT America Trial Ext Rg';
                    padding-top: 15px;
                    width: 169px;
                  "
                >
                  The reward/incentive given to the liquidator to liquidate a
                  position when its H.F. 1. Expressed in percentage.<br />
                </p>
              </template>
              <div
                @mouseenter="iconHighlight2 = false"
                @mouseleave="iconHighlight2 = true"
                v-if="themetype"
              >
                <img
                  src="../../../../assets/image/dark/question3.svg"
                  style="cursor: pointer; width: 12px; height: 12px"
                  v-if="iconHighlight2"
                />
                <img
                  src="../../../../assets/image/icon/question2.svg"
                  style="cursor: pointer; width: 12px; height: 12px"
                  v-else
                />
              </div>
              <div
                @mouseenter="iconHighlight2 = false"
                @mouseleave="iconHighlight2 = true"
                v-else
              >
                <img
                  src="../../../../assets/image/icon/question.svg"
                  style="cursor: pointer; width: 12px; height: 12px"
                  v-if="iconHighlight2"
                />
                <img
                  src="../../../../assets/image/icon/question2.svg"
                  style="cursor: pointer; width: 12px; height: 12px"
                  v-else
                />
              </div>
            </a-popover>
          </div>
          <div class="dd load1" v-if="loadingpage"></div>
          <div v-else>{{ toFixedCutZero(title.Bonus, 2, false) }}%</div>
        </div>
        <div class="loading-btn" v-if="loadingpage">
          <div class="dd2 load1"></div>
        </div>
        <div class="d2" v-else>
          <div class="b1">
            <a-button
              type="primary"
              :disabled="true"
              class="disabledtrue"
              v-if="false"
            >
              Supply
            </a-button>
            <a-button type="primary" class="btn2" @click="supplyF()">
              Supply
            </a-button>
          </div>
          <div class="b2">
            <a-button
              type="primary"
              :disabled="true"
              class="disabledtrue"
              v-if="false"
            >
              Borrow
            </a-button>
            <a-button type="primary" class="btn2" v-else @click="Borrowf()">
              Borrow
            </a-button>
          </div>
        </div>
      </div>
      <div class="info">
        <div class="left">
          <div class="t3">Supply Info</div>
          <div class="t1">
            <div class="p1">
              <div>Total Supply</div>
              <div class="li load1" v-if="loadingpage"></div>
              <div v-else>
                <div class="p2">
                  {{ toFixedCutZero(Supplyinfo.Total, 2, false) }}
                </div>
                <div class="p3">
                  ${{ toFixedNumber(Supplyinfo.TotalMoeny, 2, true) }}
                </div>
              </div>
            </div>
            <div class="p1">
              <div>APY</div>
              <div class="li load1" v-if="loadingpage"></div>
              <div v-else>
                {{ toFixedCutZero(+Supplyinfo.Apy * 100, 2, false) }}%
              </div>
            </div>
            <div class="p1">
              <div>Collateral Usage</div>
              <div class="li load1" v-if="loadingpage"></div>
              <div v-else>
                <img
                  v-if="Supplyinfo.Usage"
                  src="../../../../assets/image/icon/yes.png"
                  width="17px"
                  height="12px"
                />
                <div v-else>-</div>
              </div>
            </div>
          </div>
          <div class="line"></div>

          <div class="t4">
            <div class="legend">
              <div></div>
              <div>Supply APY</div>
            </div>
          </div>
          <SupplyEchart :supplyinfof="supplyinfof"></SupplyEchart>
          <div class="date">
            <div v-for="(item, index) in date" :key="index" class="date-main">
              <div
                class="date1"
                v-if="item.type"
                @click="ChooseDate(item.name)"
              >
                {{ item.name }}
              </div>
              <div class="date2" v-else @click="ChooseDate(item.name)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="t3">Borrow Info</div>
          <div class="t1">
            <div class="p1">
              <div>Total Borrow</div>
              <div class="li load1" v-if="loadingpage"></div>
              <div v-else>
                <div class="p2">
                  {{ toFixedCutZero(Borrowinfo.Total, 2, false) }}
                </div>
                <div class="p3">
                  ${{ toFixedNumber(Borrowinfo.TotalMoeny, 2, true) }}
                </div>
              </div>
            </div>
            <div class="p1">
              <div>APY</div>
              <div class="li load1" v-if="loadingpage"></div>
              <div v-else>
                {{ toFixedCutZero(Borrowinfo.Apy * 100, 2, false) }}%
              </div>
            </div>
            <div class="p1">
              <div style="color: transparent">Collateral Usage</div>
            </div>
          </div>
          <div class="line"></div>
          <div class="t4">
            <div class="legend2">
              <div></div>
              <div>Borrow APY</div>
            </div>
          </div>
          <BorrowEchart :borrowinfof="borrowinfof"></BorrowEchart>
          <div class="date">
            <div v-for="(item, index) in date2" :key="index" class="date-main">
              <div
                class="date1"
                v-if="item.type"
                @click="ChooseDate2(item.name)"
              >
                {{ item.name }}
              </div>
              <div class="date2" v-else @click="ChooseDate2(item.name)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MoblieSupply
      v-if="showSupplyF"
      :setShow="setShowModal"
      :TypeOperation="TypeOperation"
      :AllMyNumber="AllMyNumber"
      :wallectbanlance="wallectbanlance"
      :tokenid="tokenid"
    ></MoblieSupply>
    <MoblieEnable
      v-if="showEnable"
      :setShow="setShowModal"
      :EnableType="EnableType"
    ></MoblieEnable>
    <MoblieBorrow
      v-if="showborrow"
      :setShow="setShowModal"
      :TypeOperation="TypeOperation"
      :AllMyNumber="AllMyNumber"
      :networklists="networklists"
    ></MoblieBorrow>
    <MoblieSwitchs
      v-if="showSwitch"
      :setShow="setShowModal"
      :switchnetwork="switchnetwork"
      :switchid="switchid"
      :ismoneytype="ismoneytype"
    ></MoblieSwitchs>
    <MoblieBottom></MoblieBottom>
  </div>
</template>

<script>
import {
  getBalance,
  getChart,
  getPoolList,
  getUserInfo,
  toFixedCutZero,
  toFixedNumber,
} from '../../../../SDK';
import SupplyEchart from '../../components/SupplyEchart';
import BorrowEchart from '../../components/BorrowEchart';
import { chainIdDict } from '../../../../SDK/config';
import { mapGetters } from 'vuex';
import MoblieSupply from '../../../Dashboard/Mobile/components/MoblieSupply';
import MoblieEnable from '../../../../components/Signin/Moblie/MoblieEnable';
import MoblieBorrow from '../../../Dashboard/Mobile/components/MoblieBorrow';
import MoblieSwitchs from '../../../../components/Signin/Moblie/MoblieSwitchs';
import MoblieBottom from '../../../../components/Signin/Moblie/MoblieBottom';

export default {
  name: 'MoblieDetails',
  components: {
    MoblieBottom,
    MoblieSwitchs,
    MoblieBorrow,
    MoblieEnable,
    MoblieSupply,
    BorrowEchart,
    SupplyEchart,
  },
  computed: {
    ...mapGetters(['account', 'chainid', 'chain', 'themetype']),
  },
  data() {
    return {
      supplyinfof: {
        x: [],
        y: [],
      },
      borrowinfof: {
        x: [],
        y: [],
      },
      ismoneytype: 1,
      iconHighlight: true,
      loadingpage: false,
      toFixedNumber: toFixedNumber,
      toFixedCutZero: toFixedCutZero,
      iconHighlight1: true,
      iconHighlight2: true,
      iconHighlight3: true,
      showSupplyF: false,
      showborrow: false,
      showEnable: false,
      showSwitch: false,
      tokenlist: {},
      switchnetwork: '',
      switchid: 0,
      wallectbanlance: 0,
      tokenid: '',
      title: {},
      EnableType: {},
      networklists: [],
      TypeOperation: {},
      ChartTotalData: {},
      typeinfo: {},
      AllMyNumber: {
        AllMyborrow: 0,
        AllSupply: 0,
      },
      date: [
        {
          name: 'Year',
          type: true,
        },
        {
          name: 'Month',
          type: false,
        },
        {
          name: 'Week',
          type: false,
        },
        {
          name: 'Day',
          type: false,
        },
      ],
      types: {},
      date2: [
        {
          name: 'Year',
          type: true,
        },
        {
          name: 'Month',
          type: false,
        },
        {
          name: 'Week',
          type: false,
        },
        {
          name: 'Day',
          type: false,
        },
      ],
      Supplyinfo: {
        Total: 23.45,
        TotalMoeny: 23.45,
        Apy: 2.58,
        Usage: '-',
      },
      Borrowinfo: {
        Total: 23.45,
        TotalMoeny: 23.45,
        Apy: 2.58,
      },
      quesesticon: '',
    };
  },
  watch: {
    account(news) {
      if (news !== '') {
        this.DetailInfo();
      }
    },
  },
  created() {
    this.DetailInfo();
    this.EachartInfo();
  },
  methods: {
    async EachartInfo() {
      this.ChartTotalData = await getChart(this.$route.query.token);
      this.ChooseDate('Year');
      this.ChooseDate2('Year');
    },
    // icon(name) {
    //   if (name === "testUSDC") {
    //     return require("../../../../assets/image/icon/USDC.svg")
    //   } else if (name === "testAVAX") {
    //     return require("../../../../assets/image/icon/AVAX.svg")
    //   } else if (name === "testFTM") {
    //     return require("../../../../assets/image/icon/FTM.svg")
    //   } else if (name === "Fantom Testnet") {
    //     return require("../../../../assets/image/icon/FTM.svg")
    //   } else if (name === "USDC") {
    //     return require("../../../../assets/image/icon/USDC.svg")
    //   } else if (name === "Avalanche Testnet") {
    //     return require("../../../../assets/image/icon/AVAX.svg")
    //   } else {
    //     return require("../../../../assets/image/icon/unknown.svg")
    //   }
    // },
    icon(name) {
      if (name === 'testUSDC') {
        return require('../../../../assets/image/icon/USDC.svg');
      } else if (name === 'testAVAX') {
        return require('../../../../assets/image/icon/AVAX.svg');
      } else if (name === 'testFTM') {
        return require('../../../../assets/image/icon/FTM.svg');
      } else if (name === 'Fantom Testnet') {
        return require('../../../../assets/image/icon/FTM.svg');
      } else if (name === 'USDC') {
        return require('../../../../assets/image/icon/USDC.svg');
      } else if (name === 'Avalanche Testnet') {
        return require('../../../../assets/image/icon/AVAX.svg');
      } else if (name === 'Polygon Mumbai') {
        return require('../../../../assets/image/icon/polygon.svg');
      } else if (name === 'testMATIC') {
        return require('../../../../assets/image/icon/polygon.svg');
      } else if (name === 'testETH') {
        return require('../../../../assets/image/icon/ETHicon.svg');
      } else if (name === 'Goerli Testnet') {
        return require('../../../../assets/image/icon/ETHicon.svg');
      } else if (name === 'Arbitrum Testnet') {
        return require('../../../../assets/image/icon/Arbitrum.svg');
      } else {
        return require('../../../../assets/image/icon/unknown.svg');
      }
    },
    async DetailInfo() {
      this.loadingpage = true;
      if (this.account != '') {
        let _list = await getUserInfo();
        let list = _list?.info ?? [];
        if (list.length > 0) {
          this.loadingpage = false;
          let chains = this.$route.query.chain;
          let token = this.$route.query.token;
          let title2 = list.find((item) => item.symbol === token);
          this.tokenlist = list.map((item) => {
            return {
              ceScaled: item.ceScaled,
              dtScaled: item.dtScaled,
              increasedDebt: item.increasedDebt,
              loan: item.loan,
              liquidationPrice: item.liquidationPrice,
              name: item.name,
              withdrawable: item.withdrawable,
              myBorrow: +item.myBorrow,
              LTS: item.LTS,
              LTV: item.LTV,
              icon: require(`../../../../assets/image/icon/${item.symbol}.svg`),
              TokenName: item.symbol,
              OraclePrice: item.price,
              CollateralToken: item.mySupply,
              Collateral: item.mySupply * +item.price,
              EarnedToken: item.interestEarn,
              Earned: item.interestEarn * +item.price,
              SupplyApy: item.supplyApy * 100,
              Liquidation: 0,
              BorrowedToken: item.myBorrow,
              Borrowed: item.myBorrow * +item.price,
              PayableToken: item.interestPay,
              Payable: item.interestPay * +item.price,
              BorrowApy: +item.borrowApy * 100,
            };
          });
          this.AllMyNumber.AllSupply = _list.healthFactor.collateralValue;
          this.AllMyNumber.AllMyborrow = _list.healthFactor.debtValue;
          let Risk = list[0].LTV;
          this.AllMyNumber.AllBorrowLimt =
            this.AllMyNumber.AllSupply * Risk - this.AllMyNumber.AllMyborrow;
          this.title = {
            NetWork: chains,
            NetWorkIcon: chains,
            TokenName: title2?.symbol,
            TokenName2: title2?.name,
            TokenIcon: title2?.symbol,
            OraclePrice: title2?.price,
            AvailableLiquidity:
              (title2?.totalSupply - title2?.totalBorrow) * title2?.price,
            LTV: title2?.LTV,
            Threshold: title2?.LTS,
            Bonus: title2?.ltBonus * 100,
          };
          (this.Supplyinfo = {
            Total: title2?.totalSupply,
            TotalMoeny: title2?.totalSupply * +title2?.price,
            Apy: title2?.supplyApy,
            Usage: title2?.enable,
          }),
            (this.Borrowinfo = {
              Total: title2?.totalBorrow,
              TotalMoeny: title2?.totalBorrow * +title2?.price,
              Apy: title2?.borrowApy,
            });
        } else {
          this.loadingpage = false;
        }
      } else {
        this.loadingpage = false;
      }
    },
    supplyF() {
      let balance = getPoolList();
      let b = '';
      for (let i = 0; i < balance.length; i++) {
        if (
          this.$route.query.chain === balance[i].chain &&
          this.$route.query.token === balance[i].symbol
        ) {
          this.types = balance[i];
          b = balance[i];
          break;
        }
      }
      if (b.chainid !== this.chainid) {
        this.ismoneytype = 2;
        this.showSwitch = !this.showSwitch;
        this.switchid = b.chainid;
        this.switchnetwork = b.chain;
      } else {
        getBalance(this.types.id).then((a) => {
          if (+a.allowance <= 0) {
            this.EnableType = a;
            this.showEnable = !this.showEnable;
          } else {
            this.tokenid = this.types.id;
            this.wallectbanlance = +a.balance;
            this.TypeOperation = this.tokenlist.find(
              (item) => item.TokenName === this.$route.query.token
            );
            this.showSupplyF = !this.showSupplyF;
          }
        });
      }
    },
    Borrowf() {
      if (this.chainid === 97) {
        this.networklists = getPoolList().filter(
          (item) => item.symbol === this.title.TokenName
        );
        this.TypeOperation = this.tokenlist.find(
          (item) => item.TokenName === this.$route.query.token
        );
        this.showborrow = !this.showborrow;
      } else {
        this.switchnetwork = chainIdDict[97];
        this.switchid = 97;
        this.ismoneytype = 1;
        this.showSwitch = !this.showSwitch;
      }
    },
    setShowModal(value) {
      this.showborrow = value;
      this.showSupplyF = value;
      this.showEnable = value;
      this.showSwitch = value;
    },
    ChooseDate(name) {
      this.date = this.date.map((item) => {
        return {
          type: item.name === name,
          name: item.name,
        };
      });
      if (name === 'Year') {
        this.supplyinfof = {
          x: this.ChartTotalData.y.x,
          y: this.ChartTotalData.y.yd,
        };
      } else if (name === 'Month') {
        this.supplyinfof = {
          x: this.ChartTotalData.m.x,
          y: this.ChartTotalData.m.yd,
        };
      } else if (name === 'Week') {
        this.supplyinfof = {
          x: this.ChartTotalData.w.x,
          y: this.ChartTotalData.w.yd,
        };
      } else if (name === 'Day') {
        this.supplyinfof = {
          x: this.ChartTotalData.d.x,
          y: this.ChartTotalData.d.yd,
        };
      }
    },
    ChooseDate2(name) {
      this.date2 = this.date2.map((item) => {
        return {
          type: item.name === name,
          name: item.name,
        };
      });
      if (name === 'Year') {
        this.borrowinfof = {
          x: this.ChartTotalData.y.x,
          y: this.ChartTotalData.y.yb,
        };
      } else if (name === 'Month') {
        this.borrowinfof = {
          x: this.ChartTotalData.m.x,
          y: this.ChartTotalData.m.yb,
        };
      } else if (name === 'Week') {
        this.borrowinfof = {
          x: this.ChartTotalData.w.x,
          y: this.ChartTotalData.w.yb,
        };
      } else if (name === 'Day') {
        this.borrowinfof = {
          x: this.ChartTotalData.d.x,
          y: this.ChartTotalData.d.yb,
        };
      }
    },
    backbtn() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="scss">
.Moblie-Details {
  background: #f9f4ff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .Details-main {
    overflow: hidden;
    min-height: 100vh;
    width: calc(100% - 32px);
    padding: 77px 0px 0px 0px;
    .back {
      margin-bottom: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .chainname2 {
        height: 35px;
        width: 50%;
        border-radius: 8px;
      }
      .chainname {
        margin-left: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        img {
          height: 24px;
          width: 24px;
        }
        div {
          margin-left: 6px;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 20px;
          color: #000000;
        }
      }
    }
    .title-list {
      border: 1px solid rgba(0, 0, 0, 0.1);
      background: #ffffff;
      border-radius: 10px;
      padding: 16px;
      .icon2 {
        border-radius: 8px;
        width: 40%;
        height: 30px;
      }
      .icon {
        border-bottom: 0.5px solid rgba(0, 0, 0, 0.04);
        padding-bottom: 17px;
        margin-bottom: 16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        img {
          height: 28px;
          width: 28px;
        }

        .token-name {
          margin-left: 8px;

          .n1 {
            font-family: 'GT America Trial Ext Bd';
            font-style: normal;
            font-weight: 700;
            font-size: 15px;
            line-height: 10px;
            color: #000000;
          }
          .n2 {
            font-family: 'GT America Trial Ext Rg';
            margin-top: 6px;
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 10px;
            color: rgba(0, 0, 0, 0.7);
          }
        }
      }
      .d1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 18.5px;

        div:nth-child(1) {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 10px;
          color: rgba(0, 0, 0, 0.7);
          font-family: 'GT America Trial Ext Rg';
          span {
            font-family: 'GT America Trial Ext Rg';
            margin-right: 5px;
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 10px;
            color: rgba(0, 0, 0, 0.7);
          }
        }
        div:nth-child(2) {
          font-family: 'GT America Trial Ext md';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 15px;
          color: #000000;
        }
        .dd {
          border-radius: 8px;
          width: 25%;
          height: 25px;
        }
      }
      .d2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 18.5px;
        padding-bottom: 16px;
        border-bottom: 0.5px solid rgba(0, 0, 0, 0.04);
        div:nth-child(1) {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 10px;
          color: rgba(0, 0, 0, 0.7);
          font-family: 'GT America Trial Ext Rg';
          span {
            font-family: 'GT America Trial Ext Rg';
            margin-right: 5px;
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 10px;
            color: rgba(0, 0, 0, 0.7);
          }
        }
        div:nth-child(2) {
          font-family: 'GT America Trial Ext md';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 15px;
          color: #000000;
        }
        .dd {
          border-radius: 8px;
          width: 25%;
          height: 25px;
        }
      }
      .loading-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        .dd2 {
          height: 52px;
          width: 85%;
          border-radius: 8px;
        }
      }
      .d2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .b1 {
          width: 45%;

          ::v-deep.disabledtrue.ant-btn-disabled,
          .ant-btn.disabled,
          .ant-btn[disabled],
          .ant-btn-disabled:hover,
          .ant-btn.disabled:hover,
          .ant-btn[disabled]:hover,
          .ant-btn-disabled:focus,
          .ant-btn.disabled:focus,
          .ant-btn[disabled]:focus,
          .ant-btn-disabled:active,
          .ant-btn.disabled:active,
          .ant-btn[disabled]:active,
          .ant-btn-disabled.active,
          .ant-btn.disabled.active,
          .ant-btn[disabled].active {
            font-family: 'GT America Trial Ext Md';
            color: white;
            background: rgba(0, 0, 0, 0.1);
            border-radius: 48px;
            border-color: transparent;
            height: 52px;
            width: 152px;
            text-shadow: none;
            box-shadow: none;
          }
          ::v-deep .ant-btn-primary.btn1 {
            //width: 152px;
            max-width: 152px;
            font-family: 'GT America Trial Ext Md';
            color: #aa68f0;
            text-shadow: none;
            box-shadow: none;
            height: 52px;
            width: 100%;
            background: #ffffff;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            border: 1px solid #aa68f0;
            border-radius: 48px;
          }
          ::v-deep .ant-btn-primary.btn1:hover,
          .ant-btn-primary.btn1:focus {
            border: 1px solid transparent;
            background: rgba(170, 104, 240, 0.12) !important;
            color: #aa68f0 !important;
          }
          ::v-deep .ant-btn-primary.btn2 {
            font-family: 'GT America Trial Ext Md';
            border: 1px solid transparent;
            border-radius: 48px;
            text-shadow: none;
            box-shadow: none;
            height: 52px;
            //width: 152px;
            width: 100%;
            max-width: 152px;
            background: #aa68f0;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            color: #ffffff;
          }

          ::v-deep .btn2.ant-btn-primary:hover,
          .ant-btn-primary:focus {
            border: 1px solid transparent;
            color: #ffffff !important;
            background-color: #aa68f0cc !important;
          }
        }
        .b2 {
          display: flex;
          justify-content: flex-end;
          width: 45%;

          ::v-deep.disabledtrue.ant-btn-disabled,
          .ant-btn.disabled,
          .ant-btn[disabled],
          .ant-btn-disabled:hover,
          .ant-btn.disabled:hover,
          .ant-btn[disabled]:hover,
          .ant-btn-disabled:focus,
          .ant-btn.disabled:focus,
          .ant-btn[disabled]:focus,
          .ant-btn-disabled:active,
          .ant-btn.disabled:active,
          .ant-btn[disabled]:active,
          .ant-btn-disabled.active,
          .ant-btn.disabled.active,
          .ant-btn[disabled].active {
            font-family: 'GT America Trial Ext Md';
            color: white;
            background: rgba(0, 0, 0, 0.1);
            border-radius: 48px;
            border-color: transparent;
            height: 52px;
            //width: 152px;
            text-shadow: none;
            box-shadow: none;
            width: 100%;
          }
          ::v-deep .ant-btn-primary.btn1 {
            font-family: 'GT America Trial Ext Md';
            color: #9368f0;
            text-shadow: none;
            box-shadow: none;
            height: 52px;
            //width: 152px;
            width: 100%;
            max-width: 152px;
            background: #ffffff;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            border: 1px solid #9368f0;
            border-radius: 48px;
          }
          ::v-deep .ant-btn-primary.btn1:hover,
          .ant-btn-primary.btn1:focus {
            border: 1px solid transparent;
            background: rgba(170, 104, 240, 0.12) !important;
            color: #9368f0 !important;
          }
          ::v-deep .ant-btn-primary.btn2 {
            font-family: 'GT America Trial Ext Md';
            border: 1px solid transparent;
            border-radius: 48px;
            text-shadow: none;
            box-shadow: none;
            height: 52px;
            //width: 152px;
            width: 100%;
            max-width: 152px;
            background: #9368f0;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            color: #ffffff;
          }

          ::v-deep .btn2.ant-btn-primary:hover,
          .ant-btn-primary:focus {
            border: 1px solid transparent;
            color: #ffffff !important;
            background-color: #9368f0cc !important;
          }
        }
      }
    }
    .info {
      margin-top: 39px;
      .left {
        margin-bottom: 35px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        padding: 32px;
        background: #ffffff;
        border-radius: 16px;

        .t3 {
          font-family: 'GT America Trial Ext Bd';
          font-style: normal;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #aa68f0;
          margin-bottom: 16px;
        }
        .t1 {
          //display: flex;
          //justify-content: space-between;
          //align-items: center;

          .p1 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
            .li {
              width: 80px;
              border-radius: 4px;
              height: 16px;
              line-height: 24px;
            }
            div:nth-child(1) {
              font-family: 'GT America Trial Ext Rg';
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              line-height: 10px;
              color: rgba(0, 0, 0, 0.5);
            }
            div:nth-child(2) {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              font-family: 'GT America Trial Ext Bd';
              font-style: normal;
              font-weight: 700;
              font-size: 12px;
              line-height: 15px;
              letter-spacing: -0.01em;
              color: #000000;
              .p2 {
                margin-bottom: 4px;
                font-style: normal;
                font-weight: 700;
                font-size: 12px;
                line-height: 12px;
                letter-spacing: -0.01em;
                color: #000000;
              }
              .p3 {
                margin-top: 5px;
                font-style: normal;
                font-weight: 500;
                font-size: 10px;
                line-height: 10px;
                color: rgba(0, 0, 0, 0.5);
              }
            }
          }
        }
        .t2 {
          font-family: 'GT America Trial Ext Rg';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 32px;
          letter-spacing: -0.01em;
          color: #000000;
        }
        .l1 {
          border-radius: 4px;
          height: 16px;
          width: 65%;
          line-height: 24px;
        }
        .date {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .date-main {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .date1 {
              cursor: pointer;
              border: 1px solid transparent;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 60px;
              height: 26px;
              background: #aa68f0;
              border-radius: 19px;
              color: #ffffff;
              font-style: normal;
              font-weight: 500;
              font-size: 12px;
              line-height: 100%;
              font-family: 'GT America Trial Ext Md';
            }
            .date2 {
              cursor: pointer;
              border: 1px solid transparent;
              font-family: 'GT America Trial Ext Md';
              display: flex;
              justify-content: center;
              align-items: center;
              background: rgba(0, 0, 0, 0.02);
              border-radius: 19px;
              width: 60px;
              height: 26px;
              font-style: normal;
              font-weight: 500;
              font-size: 12px;
              line-height: 100%;
              color: rgba(0, 0, 0, 0.3);
            }
          }
        }
        .t4 {
          margin-top: 34px;
          margin-bottom: 51px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .legend {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            div:nth-child(1) {
              height: 6px;
              width: 6px;
              border-radius: 50%;
              background: #aa68f0;
            }
            div:nth-child(2) {
              margin-left: 6px;
              font-style: normal;
              font-weight: 500;
              font-size: 12px;
              line-height: 22px;
              color: #000000;
              font-family: 'GT America Trial Ext Md';
            }
          }
        }
        .line {
          margin-top: 16px;
          border: 0.5px solid rgba(0, 0, 0, 0.04);
        }
      }
      .right {
        border: 1px solid rgba(0, 0, 0, 0.1);
        padding: 32px;
        background: #ffffff;
        border-radius: 16px;

        .t3 {
          font-family: 'GT America Trial Ext Bd';
          font-style: normal;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #9368f0;
          margin-bottom: 16px;
        }
        .t1 {
          .p1 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
            .li {
              width: 80px;
              border-radius: 4px;
              height: 16px;
              line-height: 24px;
            }
            div:nth-child(1) {
              font-family: 'GT America Trial Ext Rg';
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              line-height: 10px;
              color: rgba(0, 0, 0, 0.5);
            }
            div:nth-child(2) {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              font-family: 'GT America Trial Ext Bd';
              font-style: normal;
              font-weight: 700;
              font-size: 12px;
              line-height: 15px;
              letter-spacing: -0.01em;
              color: #000000;

              .p2 {
                margin-bottom: 4px;
                font-style: normal;
                font-weight: 700;
                font-size: 12px;
                line-height: 12px;
                letter-spacing: -0.01em;
                color: #000000;
              }
              .p3 {
                margin-top: 5px;
                font-style: normal;
                font-weight: 500;
                font-size: 10px;
                line-height: 10px;
                color: rgba(0, 0, 0, 0.5);
              }
            }
          }
        }
        .t2 {
          font-family: 'GT America Trial Ext Rg';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 32px;
          letter-spacing: -0.01em;
          color: #000000;
        }
        .date {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .date-main {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .date1 {
              font-family: 'GT America Trial Ext Md';
              display: flex;
              justify-content: center;
              align-items: center;
              width: 60px;
              height: 26px;
              background: #9368f0;
              border-radius: 19px;
              color: #ffffff;
              font-style: normal;
              font-weight: 500;
              font-size: 12px;
              line-height: 100%;
            }
            .date2 {
              font-family: 'GT America Trial Ext Md';
              display: flex;
              justify-content: center;
              align-items: center;
              background: rgba(0, 0, 0, 0.02);
              border-radius: 19px;
              width: 60px;
              height: 26px;
              font-style: normal;
              font-weight: 500;
              font-size: 12px;
              line-height: 100%;
              color: rgba(0, 0, 0, 0.3);
            }
          }
        }
        .t4 {
          margin-top: 34px;
          margin-bottom: 51px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .legend2 {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            div:nth-child(1) {
              height: 6px;
              width: 6px;
              border-radius: 50%;
              background: #9368f0;
            }
            div:nth-child(2) {
              margin-left: 6px;
              font-style: normal;
              font-weight: 500;
              font-size: 12px;
              line-height: 22px;
              color: #000000;
              font-family: 'GT America Trial Ext Md';
            }
          }
        }
        .line {
          margin-top: 16px;
          border: 0.5px solid rgba(0, 0, 0, 0.04);
        }
      }
    }
  }
}
</style>
